import axios, { AxiosError } from 'axios';
import moment from 'moment';
import api from '../api';

const env = (window as any).env ?? { VERSION: '0.0.0', API_ENDPOINT: '' }
const headers = { 'synkedup-version': `web ${env.version}` }

type TokenResponse = {
  access_token: string
  refresh_token: string
  token_type: string
  expires: string
}

export type Token = {
  access_token: string
  refresh_token: string
  type: string
  expires: string
}

export const signIn = async (username: string, password: string): Promise<Token> => {
  try {
    const res = await axios.post<TokenResponse>(`${env.API_ENDPOINT}/token`, { userName: username, password }, { headers });
    return {
      access_token: res.data.access_token,
      refresh_token: res.data.refresh_token,
      type: res.data.token_type,
      expires: res.data.expires
    }
  } catch (error: any) {
    const message = (error as AxiosError<{ message: string }>).response?.data?.message
    throw new Error(message)
  }
}

export const signOut = async (): Promise<void> => {
  await api.post(`${env.API_ENDPOINT}/token/sign-out`, {});
}

export const forgotPassword = async (email: string): Promise<string> => {
  try {
    const result = await axios.post<string>(`${env.API_ENDPOINT}/account/forgot-password`, { email }, { headers });
    return result.data
  } catch (error: any) {
    const message = (error as AxiosError<{ message: string }>).response?.data?.message
    throw new Error(message)
  }
}

export const resetPassword = async (email: string, token: string, password: string): Promise<string> => {
  const body = {
    email,
    token,
    password,
    confirmPassword: password
  }
  try {
    const result = await axios.post<string>(`${env.API_ENDPOINT}/account/reset-password`, body, { headers });
    return result.data
  } catch (error: any) {
    const message = (error as AxiosError<{ message: string }>).response?.data?.message
    throw new Error(message)
  }
}

export const authTenantEndpoint = `/web/authentication/tenant`

export const authenticateToTenant = async(tenantId: number): Promise<Token>  => {
  const response = (await api.post(`${authTenantEndpoint}/${tenantId}`)).data
  return {
    access_token: response.access_token,
    refresh_token: response.refresh_token,
    type: response.token_type,
    expires: moment(response.expires).toISOString()
  }
}
